import type {
  AlternateURLs,
  Languages,
} from "next/dist/lib/metadata/types/alternative-urls-types"

type LocalePrefix = "as-needed" | "always" | "never"

export const selectorOptions = [
  {
    label: "English",
    locale: "en-US",
  },
  {
    label: "Español",
    locale: "es",
  },
  {
    label: "Deutsch",
    locale: "de-DE",
  },
  {
    label: "Français",
    locale: "fr",
  },
  {
    label: "日本語",
    locale: "ja",
  },
  {
    label: "한국어",
    locale: "kr",
  },
  {
    label: "中文 (简体)",
    locale: "zh-CN",
  },
  {
    label: "中文 (繁体)",
    locale: "zh-TW",
  },
] as const

export const locales = selectorOptions.map(option => option.locale)

export function getAlternates(url: string): AlternateURLs {
  return {
    canonical: url,
    languages: locales.reduce(
      (acc, locale) => {
        if (isDefaultLocale(locale)) {
          acc[locale] = url
        } else if (url === "/") {
          acc[locale] = `/${locale}`
        } else {
          acc[locale] = `/${locale}${url}`
        }

        return acc
      },
      {} as Languages<string>,
    ),
  }
}

export const defaultLocale = selectorOptions[0].locale

export type Locale = (typeof locales)[number]

export const localePrefix: LocalePrefix = "as-needed"

export const isValidLocale = (locale: string | undefined): locale is Locale => {
  return locales.includes(locale as Locale)
}

export const isDefaultLocale = (
  locale: Locale,
): locale is typeof defaultLocale => {
  return locale === defaultLocale
}

export function parseLocale(locale: string | undefined): Locale {
  if (locales.includes(locale as Locale)) {
    return locale as Locale
  }
  return defaultLocale
}

// biome-ignore lint/complexity/noBannedTypes: this is fine as its just a default
export type LocaleParams<T extends Record<string, string> = {}> = T & {
  locale: Locale
}

export function getLocaleStaticParams() {
  return [{ locale: defaultLocale }]
  // return locales.map(locale => ({ locale }))
}
